import { Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { HvlBaseModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { BasicTimeConstrainedBaseModel } from './basic-time-constrained-base-model';

@JsonObject('KovanHrTimeConstrainedBaseModel')
export class TimeConstrainedBaseModel extends BasicTimeConstrainedBaseModel {
    @Required()
    @JsonProperty('count', Number, true)
    count: number = null;
}
